import { mapActions } from "vuex";
import * as types from "@/store/types";

export default {
  name: "profile-avatar",
  props: ["isVerify"],
  data() {
    return {
      isHover: false
    };
  },
  methods: {
    ...mapActions({
      setAccountSidebar: types.account.actions.SET_SIDEBAR
    }),
    openAccountSidebar() {
      this.setAccountSidebar(true);
    },
    setHover(bool) {
      this.isHover = bool;
    }
  }
};
